import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import { PageName } from '@/enums/pageName'
import { CheckoutFlowVersion } from '@/enums/payments'
import { getPath } from '@/utils/urlUtils'

import { TextHTML } from '@/components/typography'

import { emailKey } from '@/auth/types'
import { useAuth } from '@/auth/useAuth'
import { useSession } from '@/core/session/useSession'
import { trackPageView } from '@/events/events'

import { TAlreadyPaidPageProps } from './types'

const pageName = PageName.alreadyPaid

export const AlreadyPaidPage = ({ alreadyPaidPage, getItem, config }: TAlreadyPaidPageProps) => {
  const { user } = useAuth()
  const sessionContext = useSession()

  const email = getItem(emailKey)

  const { title, pageTitle, text, contactsText } = alreadyPaidPage

  const pageDescription = email ? text(email) : text('your email')

  useEffect(
    () => {
      if (!email && sessionContext.checkoutFlowVersion != CheckoutFlowVersion.V2) {
        return
      }
      trackPageView(
        pageName,
        config.PARTNER_ID,
        config.APP_ID,
        config.PAGE_SET_ID,
        sessionContext,
        user
      )
      document.title = pageTitle ? pageTitle : title
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (!email && sessionContext.checkoutFlowVersion != CheckoutFlowVersion.V2) {
    return <Navigate to={getPath(PageName.registration)} replace />
  }

  const className = `page page-${pageName}`

  return (
    <div className={className}>
      <TextHTML className="page-title" title={title} />
      <div className="page-description">{pageDescription}</div>
      <div className="contacts-container">
        <TextHTML title={contactsText}></TextHTML>
      </div>
    </div>
  )
}
